import { render, staticRenderFns } from "./role-add.vue?vue&type=template&id=6ff39cf0&scoped=true&"
import script from "./role-add.vue?vue&type=script&lang=js&"
export * from "./role-add.vue?vue&type=script&lang=js&"
import style0 from "./role-add.vue?vue&type=style&index=0&id=6ff39cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff39cf0",
  null
  
)

export default component.exports